import './_collection-delivery-selection-form.scss';
import component from './collection-delivery-selection-form';

export default component;
